import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import { Toaster } from './components/ui/sonner';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route
                            path="/*"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <Toaster theme="dark" position="bottom-right" mobileOffset={{ bottom: 72 }} toastOptions={{ style: { background: '#09090b', border: '1px solid #27272a', color: '#fafafa', fontFamily: 'Chivo' } }} />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
